import { ComponentPropsWithoutRef, createContext } from 'react';

import * as SelectPrimitive from '@radix-ui/react-select';

export const SelectContext = createContext<{
  value?: string;
}>({
  value: '',
});

export default function Select({
  children,
  ...otherProps
}: ComponentPropsWithoutRef<typeof SelectPrimitive.Root>): JSX.Element {
  return (
    <SelectContext.Provider
      value={{
        value: otherProps.value,
      }}
    >
      <SelectPrimitive.Root {...otherProps}>{children}</SelectPrimitive.Root>
    </SelectContext.Provider>
  );
}
